import { useEffect, useState, type FormEvent } from 'react'
import { desktopLoginApi, desktopOpenURL, type DesktopLoginInfo } from '@/lib/desktopLogin'
import { describeError } from '@/lib/auth'
import { useAuthStore } from '@/store/auth'
import styles from './AuthPage.module.css'

export function DesktopLoginPage({ id, onDone }: { id: string; onDone: () => void }) {
  const user = useAuthStore((s) => s.user)
  const signOut = useAuthStore((s) => s.signOut)
  const [info, setInfo] = useState<DesktopLoginInfo | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)
  const [expired, setExpired] = useState(false)
  useEffect(() => {
    let mounted = true
    let timer: ReturnType<typeof setTimeout>
    void desktopLoginApi.info(id).then((value) => {
      if (!mounted) return
      setInfo(value)
      if (value.status !== 'pending') setError('Запрос уже обработан. Начните вход заново в приложении.')
      timer = setTimeout(() => setExpired(true), value.expires_in * 1000)
    }).catch((err: unknown) => { if (mounted) setError(describeError(err).message) })
    return () => { mounted = false; clearTimeout(timer) }
  }, [id])
  const approve = async (e: FormEvent) => {
    e.preventDefault()
    setBusy(true); setError(null)
    try { await desktopLoginApi.approve(id); setDone(true) }
    catch (err) { setError(describeError(err).message) }
    finally { setBusy(false) }
  }
  const deny = async () => {
    setBusy(true); setError(null)
    try { await desktopLoginApi.deny(id); onDone() }
    catch (err) { setError(describeError(err).message) }
    finally { setBusy(false) }
  }
  return <div className={styles.page}><div className={styles.card}>
    <img className={styles.brand} src="/brand/mark.png" alt="Кличат" width={56} height={56} />
    {done ? <div className={styles.form}>
      <h1 className={styles.title}>Вход подтверждён</h1>
      <p className={styles.subtitle}>Вернитесь в приложение Кличата.</p>
      <button type="button" className={styles.primary} onClick={() => { window.location.href = desktopOpenURL() }}>Открыть Кличат</button>
      <button type="button" className={styles.link} onClick={onDone}>Продолжить в браузере</button>
    </div> : <form className={styles.form} onSubmit={(e) => void approve(e)}>
      <h1 className={styles.title}>Войти в приложение</h1>
      <p className={styles.muted}>Учётная запись: <strong>@{user?.username}</strong></p>
      {info ? <p className={styles.muted}>{info.device}{info.ip ? ` · ${info.ip}` : ''}</p> : null}
      <p className={styles.hint}>Подтверждайте только вход, который начали сами.</p>
      {expired ? <p className={styles.error} role="alert">Запрос истёк. Начните вход заново в приложении.</p> : null}
      {error ? <p className={styles.error} role="alert">{error}</p> : null}
      <button type="submit" className={styles.primary} disabled={busy || expired || !info || info.status !== 'pending'}>{busy ? 'Подтверждаем…' : 'Войти в приложении Кличата'}</button>
      <button type="button" className={styles.link} disabled={busy} onClick={() => void signOut()}>Войти в другую учётную запись</button>
      <button type="button" className={styles.link} disabled={busy} onClick={() => void deny()}>Не подтверждать</button>
    </form>}
  </div></div>
}
